export default "__VITE_ASSET__DC70$JHo__"